import React from 'react'
import { Input } from 'antd'
import PropTypes from 'prop-types'

const ZipInput = ({
  size = 'large',
  placeholder = '12345',
  maxLength = 5,
  onKeyDown: customOnKeyDown,
  ...inputProps
}) => {
  const handleKeyDown = (e) => {
    // Allow only numbers and navigation keys
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End',
    ]

    // Allow numbers and specified navigation keys
    if (!/\d/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault()
    }

    // Call custom onKeyDown if provided
    if (customOnKeyDown) {
      customOnKeyDown(e)
    }
  }

  return (
    <Input
      type="tel"
      size={size}
      placeholder={placeholder}
      maxLength={maxLength}
      onKeyDown={handleKeyDown}
      {...inputProps}
    />
  )
}

ZipInput.propTypes = {
  size: PropTypes.oneOf(['small', 'middle', 'large']),
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  onKeyDown: PropTypes.func,
}

export default ZipInput
